import { noop } from 'lodash';

import PreviewVideoPlayer from '@components/share/media/previewVideoPlayer';
import BaseModalWrapper from '@components/share/modal/baseModalWrapper';
import { Box } from '@mui/material';
import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { VideoFileType } from '@common/type/Filetype';

type VideoPreviewModalProps = {
  open?: boolean;
  onClose: typeof noop;
  videoUrl: string;
  thumbnailUrl: string;
};

const VideoPreviewModal = ({
  open,
  onClose,
  videoUrl,
  thumbnailUrl,
}: VideoPreviewModalProps) => {
  return (
    <Box >
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          borderRadius: '100%',
          width: '70px',
          height: '70px',
          zIndex: 1000000,
          padding: 'unset',
          backgroundColor: '#00000059',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',  
          cursor: 'pointer',
        }}
        onClick={onClose}
      >
        <FontAwesomeIcon icon="fa-sharp fa-regular fa-xmark" style={{ color: 'white', fontSize: '30px' }} />
      </Box>
     
      <BaseModalWrapper
        open={open}
        onClose={onClose}
        maxWidth={1024}
        disabledBackDrop
        hideCloseButton
        keepMounted={false}
        boxStyle={{
          overflow: 'hidden',
        }}
        paperStyle={{
          width: { lg: 1024, md: 720, xs: 327 },
          height: { lg: 572, md: 402, xs: 183 },
          overflow: 'hidden',
          padding: 'unset',
        }}
      >
        <PreviewVideoPlayer
          videoUrl={videoUrl}
          thumbUrl={thumbnailUrl}
          className="degree-landing-page-video-preview-modal"
          videoType={VideoFileType.MP4}
          disabledVideoQualities
        />
      </BaseModalWrapper>
    </Box>
  );
};

export default VideoPreviewModal;
